import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import { isValueEmpty, getUtcToLocalByFormat } from '@awp/helpers/utilsReact';
import { setHours, setMinutes, subDays, format as formatDate } from 'date-fns';
import SensorLink from './SensorLink';
const txtFontSize = {
  fontSize: '85%',
};

const SegmentInfo = ({ segment }) => {
  console.log(segment);
  console.log(formatDate(new Date(segment.SegmentEffectiveTimestamp), 'yyyy-MM-dd HH:mm'));
  console.log(formatDate(new Date(segment.SegmentEndTimestamp), 'yyyy-MM-dd HH:mm'));

  return (
    segment && (
      <>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>Source Name</b>
            </Form.Label>
            <br />
            <div style={txtFontSize}>{segment.SourceName}</div>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>Start Date</b>
            </Form.Label>
            <br />
            <div style={txtFontSize}>
              {getUtcToLocalByFormat(segment.SegmentEffectiveTimestamp, 'yyyy-MM-dd HH:mm')}
            </div>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>End Date</b>
            </Form.Label>
            <br />
            <div style={txtFontSize}>
              {isValueEmpty(segment.SegmentEndTimestamp)
                ? ''
                : getUtcToLocalByFormat(segment.SegmentEndTimestamp, 'yyyy-MM-dd HH:mm')}
            </div>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>Sensor</b>
            </Form.Label>
            <br />
            <div style={txtFontSize}>
              <SensorLink segment={segment} />
            </div>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>Polling Interval</b>
            </Form.Label>
            <br />
            <div style={txtFontSize}>
              {isValueEmpty(segment.CollectionIntervalMinutes) ? 'N/A' : segment.CollectionIntervalMinutes + ' min'}
            </div>
          </Form.Group>
        </Col>
      </>
    )
  );
};

SegmentInfo.propTypes = {
  segment: PropTypes.any.isRequired,
};

export default SegmentInfo;
